import { render, staticRenderFns } from "./AuthenticationRecoveryCodesModal.vue?vue&type=template&id=2fdcb1f5"
import script from "./AuthenticationRecoveryCodesModal.vue?vue&type=script&lang=js"
export * from "./AuthenticationRecoveryCodesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports